import React, { useEffect, useState } from "react";
import { Link, useNavigate } from "react-router-dom";

import { FaXmark, FaX } from "react-icons/fa6";

import SectionHeader from "../../components/SectionHeader";

import { useDispatch, useSelector } from "react-redux";
import {
  removeFromCart,
  fetchCartItems,
  addToCart,
  updateCart,
} from "../../store2/features/cartSlice";

export default function Notification() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const cart = useSelector((state) => state.cart.items);
  const loading = useSelector((state) => state.cart.loading);
  const cartCount = useSelector((state) => state.cart.cartItems);

  const [cartItems, setCartItems] = useState(cart);
  const [userDetails, setUserDetails] = useState(false);

  useEffect(() => {
    dispatch(fetchCartItems());
    console.log("Cart count" + cartCount);
  }, [dispatch]);

  useEffect(() => {
    setCartItems(cart);
    const userDetailss = localStorage.getItem("userDetails");
    if (userDetailss) {
      setUserDetails(JSON.parse(userDetailss));
    }
  }, [cart]);

  useEffect(() => {
    document.title = "Notifications";
  }, []);

  return (
    cartItems && (
      <>
        <div className=" sectionWrapper cart-wrapper">
          <div className="container mt-2 mb-5">
            {/* {cartItems.cartResponseWOList && cartItems.cartResponseWOList.length === 0 ? ( */}
            {/* {cartItems && cartItems.length === 0 && !loading ? ( */}
            <>
              <div className="col-md-6">
                <SectionHeader className="">
                  <span className="subtitle">Notification</span>
                  <h2 className="title">
                    Your <span>Notifications</span>{" "}
                  </h2>
                </SectionHeader>
              </div>
              <div className="d-flex justify-content-center align-items-center vh-50 mb-6">
                <div className="text-center">
                  <p className="display-6 fw-bold">No Notifications</p>
                </div>
              </div>
            </>
          </div>
        </div>
      </>
    )
  );
}
